import axios from "axios"
import React, { useState } from "react"
import "../App.css"
import { SERVER_URI } from "../utility/config"
import LoginRequest from "./LoginRequest"

function AppMinVersionsUpdatedMessage(props) {
	window.setTimeout(function () {
		props.handleClose()
	}, 1700)

	return (
		<div>
			<h2 className="message_title">Vahvistettu</h2>
		</div>
	)
}

function SetAppMinVersions(props) {
	const [show, setShow] = useState(false)
	const [validationError, setValidationError] = useState("")
	const [userData, setUserData] = useState({
		customerMinVersion: props.currentCustomerMinVersion,
		driverMinVersion: props.currentDriverMinVersion,
	})
	let storage = window.localStorage
	let userToken = storage.getItem("admin_token")

	const onChange = (e) => {
		setValidationError("")
		setUserData({ ...userData, [e.target.name]: e.target.value })
	}

	const isValidSemver = (value) => /^\d+\.\d+\.\d+$/.test(value)

	const doSubmit = async (e) => {
		e.preventDefault()
		if (!isValidSemver(userData.customerMinVersion) || !isValidSemver(userData.driverMinVersion)) {
			setValidationError("Version tulee olla muodossa MAJOR.MINOR.PATCH, esimerkiksi 1.0.0")
			return
		}

		try {
			await Promise.all([
				axios.put(`${SERVER_URI}/set_customer_app_min_version/`, {
					minimumVersion: userData.customerMinVersion,
				}, {
					headers: { Authorization: `Token ${userToken}` },
				}),
				axios.put(`${SERVER_URI}/set_driver_app_min_version/`, {
					minimumVersion: userData.driverMinVersion,
				}, {
					headers: { Authorization: `Token ${userToken}` },
				}),
			])

			props.dispatch({
				type: "UPDATE_CUSTOMER_APP_MIN_VERSION",
				data: { minimumVersion: userData.customerMinVersion },
			})
			props.dispatch({
				type: "UPDATE_DRIVER_APP_MIN_VERSION",
				data: { minimumVersion: userData.driverMinVersion },
			})

			setShow(true)
		} catch (e) {
			console.log("Error in setting app minimum versions.", e)
		}
	}

	return (
		<div className="popUp_card">
			<div className="popup-box">
				<div className="box">
					<span className="close-icon" onClick={props.handleClose}>
						x
					</span>
					{!show && (
						<div>
							<h2 className="popUp_title">Aseta sovelluksen vähimmäisversiot</h2>
							<form className="rejectionReason_form" onSubmit={(e) => doSubmit(e)}>
								<label className="label_add" htmlFor="customerMinVersion">
									Asiakas-sovellus:
								</label>
								<input
									id="customerMinVersion"
									name="customerMinVersion"
									onChange={onChange}
									value={userData.customerMinVersion}
									required></input>
								<br className="desktop-break" />
								<label className="label_add" htmlFor="driverMinVersion">
									Kuljettaja-sovellus:
								</label>
								<input
									id="driverMinVersion"
									name="driverMinVersion"
									onChange={onChange}
									value={userData.driverMinVersion}
									required></input>
								<br className="desktop-break" />
								{validationError.length > 0 && <p>{validationError}</p>}
								<input type="submit" id="gradient_Button" value="Aseta vähimmäisversiot" />
							</form>
						</div>
					)}
					{show && <AppMinVersionsUpdatedMessage handleClose={props.handleClose} />}
				</div>
			</div>
		</div>
	)
}

function AppMinVersions(props) {
	props.stopListRefresh()
	const [isOpen, setIsOpen] = useState(false)

	const togglePopUp = async () => {
		setIsOpen(!isOpen)
	}

	return (
		<div className="configurations">
			{isOpen && (
				<SetAppMinVersions
					dispatch={props.dispatch}
					currentCustomerMinVersion={props.customerAppMinVersion}
					currentDriverMinVersion={props.driverAppMinVersion}
					handleClose={togglePopUp}
				/>
			)}
			<h3>Sovelluksen vähimmäisversiot</h3>
			<div className="rides">
				{props.customerAppMinVersion === undefined || props.driverAppMinVersion === undefined ? (
					<LoginRequest />
				) : (
					<div className="customer_list">
						Asiakas: {props.customerAppMinVersion}
						<br />
						Kuljettaja: {props.driverAppMinVersion}
						<br />
					</div>
				)}
			</div>
			<button id="gradient_Button" onClick={togglePopUp}>
				Aseta vähimmäisversiot
			</button>
		</div>
	)
}

export default AppMinVersions
